// See web/app/themes/jcf-theme/acf/carousel-module.twig

import "slick-carousel";
import $ from "jquery";

class CardCarousel {
  init() {
    let $buttons = $('[data-carousel="cards-nav"] [data-slide]');

    $(window).on("orientationchange resize", function () {
      $('[data-carousel="cards"]').slick("resize");
    });

    $(document).ready(function () {
      $('[data-carousel="cards"]')
        .on("beforeChange", function (event, slick, currentSlide, nextSlide) {
          $buttons
            .eq(nextSlide)
            .addClass("active")
            .siblings()
            .removeClass("active prev");
          $buttons.eq(nextSlide).prevUntil().addClass("prev");
        })
        .slick({
          dots: true,
          arrows: true,
          mobileFirst: true,
          slidesToShow: 1,
          infinite: false,
          variableWidth: true,
          centerPadding: "4rem",
          customPaging: function (slider, i) {
            // this example would render "tabs" with titles
            var n = ("0" + (i + 1)).slice(-2);
            return `<span class="dot" data-no="${n}">${n}</span>`;
          },
          responsive: [
            {
              breakpoint: 1392,
              settings: {
                dots: false,
                arrows: true,
                slidesToShow: 3,
              },
            },
            {
              breakpoint: 640,
              settings: {
                dots: true,
                arrows: true,
                slidesToShow: 2,
              },
            },
          ],
        });

      $buttons.click(function (event) {
        event.preventDefault();
        var slide = $(this).data("slide");
        $(this).addClass("active").siblings().removeClass("active prev");
        $(this).prevUntil().addClass("prev");
        $('[data-carousel="cards"]').slick("slickGoTo", slide - 1);
      });
    });
  }
}

export default CardCarousel;
